import punishmentInfoReducer from "./reducers";
export { default as punishmentInfoTypes } from "./types";
export { default as punishmentInfoOperations } from "./operations";
export default punishmentInfoReducer;
